import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: "wrap"
    },
    blur: {
        filter: "blur(2px)"
    },
    disciplineContainer: {
        minWidth: 400 + 16,
        margin: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(2),
        minWidth: 300
    },
    formControlDate: {
        margin: theme.spacing(2),
        minWidth: 200 - 8
    },
    chip: {
        minWidth: 300,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        paddingTop: 25,
        paddingBottom: 25,
        margin: 5,
    },
    multiSelectContainer: {
        margin: theme.spacing(2),
        width: 700 + 48
    },
    dropdownLabel: {
        backgroundColor: theme.palette.background.default
    },
    openClosedContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: 5,
        minWidth: 100
    },
    openClosedDescriptionColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}));

export {useStyles};
